import { hasValue } from '@helpers/utils/utils.js';
import { jsonUtils, parseJson } from './jsonUtils';

export const sessionStorageUtils = {
  hasKey: (key) => {
    const value = sessionStorage.getItem(key);
    return hasValue(value);
  },
  getItem: (key) => {
    try {
      const serializedData = sessionStorage.getItem(key);
      return jsonUtils(serializedData)
        ? parseJson(serializedData)
        : serializedData;
    } catch (err) {
      console.error('Error getting item from sessionStorage:', err);
      return null;
    }
  },
  setItem: (key, data) => {
    try {
      const serializedData = JSON.stringify(data);
      sessionStorage.setItem(key, serializedData);
    } catch (err) {
      console.error('Error setting item in sessionStorage:', err);
    }
  },
  removeItem: (key) => {
    try {
      sessionStorage.removeItem(key);
    } catch (err) {
      console.error('Error removing item from sessionStorage:', err);
    }
  },
  clear: () => {
    try {
      sessionStorage.clear();
    } catch (err) {
      console.error('Error clearing sessionStorage:', err);
    }
  },
};
